import { UserState, UserPermission } from '@/interfaces/user';
import { createContext, useContext, useState, ReactNode } from 'react';

interface SheetContextType {
  open: boolean;
  states: Array<UserState>;
  permissions: Array<UserPermission>;
  hasSingleState: boolean;
  setOpen: (_open: boolean) => void;
  setStates: (_states: Array<UserState>) => void;
  setPermissions: (_permissions: Array<UserPermission>) => void;
  setHasSingleState: (_hasSingleState: boolean) => void;
}

const SheetContext = createContext({
  open: false,
  states: [],
  permissions: [],
  hasSingleState: false,
  setOpen: (_open: boolean) => {},
  setStates: (_states: Array<UserState>) => {},
  setPermissions: (_permissions: Array<UserPermission>) => {},
  setHasSingleState: (_hasSingleState: boolean) => {},
} as SheetContextType);

export const useSheet = () => useContext(SheetContext);

export function SheetProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [states, setStates] = useState<Array<UserState>>([]);
  const [permissions, setPermissions] = useState<Array<UserPermission>>([]);
  const [hasSingleState, setHasSingleState] = useState(false);

  return (
    <SheetContext.Provider
      value={{ open, states, permissions, hasSingleState, setOpen, setStates, setPermissions, setHasSingleState }}
    >
      {children}
    </SheetContext.Provider>
  );
}
